
const digest = 'b3d1586a9463392bb238dbbae39fe5f708fad0308001915fae7b811a8328746c';
const classes = {"errorMessage":"_errorMessage_1myob_1"};
const css = `._errorMessage_1myob_1 {
  font-family: Poppins, sans-serif;
  font-size: 14px;
  color: #d81616;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  